<!-- scrim closes the drawer on outside click -->
@if (svc.open()) { <div class="tb-scrim" (click)="svc.close()"></div> }

<div class="tb-drawer" [class.open]="svc.open()" role="dialog" aria-label="Toolbox">
  <div class="tb-drawer-inner">
    <div class="tb-head">
      <span class="tb-head-title"><app-icon name="Toolbox" [size]="16"></app-icon> Toolbox</span>
      <button class="tb-head-close" (click)="svc.close()" title="Close"><app-icon name="Close" [size]="14"></app-icon></button>
    </div>
    <div class="tb-tools">
      @for (t of tools; track t.id) {
        <button class="tb-tile" [class.active]="isActive(t.id)" (click)="openTool(t)">
          <span class="tb-tile-ic"><app-icon [name]="t.icon" [size]="24"></app-icon></span>
          <span class="tb-tile-name">{{ t.name }}</span>
          <span class="tb-tile-desc">{{ t.desc }}</span>
        </button>
      }
    </div>
  </div>
  <button class="tb-tab" (click)="svc.toggle()" title="Toolbox">
    <app-icon name="Toolbox" [size]="15"></app-icon>
    <span class="tb-tab-caret" [class.up]="svc.open()"><app-icon name="Chevron" [size]="12"></app-icon></span>
  </button>
</div>

<!-- floating windows -->
@for (w of wins(); track w.key) {
  <div class="fw" [style.left.px]="w.x" [style.top.px]="w.y" [style.width.px]="w.w" [style.zIndex]="w.z"
       (pointerdown)="focusWin(w.key)">
    <div class="fw-bar" (pointerdown)="startDrag(w.key, $event)">
      <span class="fw-title">
        <span class="fw-ic">
          @if (w.glyph) { {{ w.glyph }} } @else { <app-icon [name]="w.iconName!" [size]="15"></app-icon> }
        </span>{{ w.name }}
      </span>
      <button class="fw-close" (click)="closeWin(w.key)" title="Close"><app-icon name="Close" [size]="13"></app-icon></button>
    </div>
    <div class="fw-body" [class]="w.bodyClass ?? ''">
      @if (w.gameId) {
        @switch (w.gameId) {
          @case ('numbermatch') { <app-number-match [embedded]="true"></app-number-match> }
          @case ('memorymatch') { <app-memory-match></app-memory-match> }
          @case ('minesweeper') { <app-mini-minesweeper></app-mini-minesweeper> }
          @case ('2048') { <app-mini-2048></app-mini-2048> }
          @case ('sudoku') { <app-mini-sudoku></app-mini-sudoku> }
          @case ('chess') { <app-mini-chess></app-mini-chess> }
          @case ('connectfour') { <app-mini-connect-four></app-mini-connect-four> }
        }
      } @else {
        @switch (w.key) {
          @case ('calc') { <app-calculator></app-calculator> }
          @case ('fx') { <app-currency-converter></app-currency-converter> }
          @case ('games') { <app-games-gallery (play)="openGame($event)"></app-games-gallery> }
          @case ('wallboard') { <app-wallboard [embedded]="true"></app-wallboard> }
        }
      }
    </div>
  </div>
}
